<ion-content class="ion-padding">
    <div class="inner-content">
        <h2> {{ 'usersSync.userSyncProcess' | translate | uppercase }}</h2>

        <ion-row class="upper" margin-top margin-bottom>
            <ion-col *ngIf="frozenStructureEnabled" size="6">
                <ion-item lines="none">
                    <ion-button size="default" color="primary" (click)="openFrozenStructureDialog()" mode="ios">
                        {{ 'frozenStructure.openDialog' | translate }}
                    </ion-button>
                </ion-item>
            </ion-col>
            <ion-col [size]="frozenStructureEnabled ? 6 : 12">
                <ion-item lines="none">
                    <ion-button size="default" slot="end" color="primary" (click)="sendLastDayEmail()" mode="ios">
                        {{ 'usersSync.sendLastDay' | translate }}
                    </ion-button>
                    <ion-button size="default" slot="end" color="primary" (click)="file.click()" mode="ios">
                        {{ 'usersSync.newSync' | translate }}
                    </ion-button>
                    <input class="input-file" type="file" accept=".csv" hidden
                           (change)="setDocumentFile($event.target.files)" #file/>
                </ion-item>
            </ion-col>
        </ion-row>


        <table mat-table matSort [dataSource]="processes" class="mat-elevation-z8">
            <ng-container matColumnDef="status">
                <th width="8%" mat-header-cell *matHeaderCellDef> Status</th>
                <td width="8%" mat-cell *matCellDef="let row">
                    <img
                            *ngIf="row.importStatus === 0"
                            src="./assets/imgs/status-success.png"
                            alt="Success"
                    />
                    <img
                            *ngIf="row.importStatus === 1"
                            style="cursor: pointer;"
                            (click)="openErrorsDialog(row)"
                            src="./assets/imgs/status-error.png"
                            alt="Error"
                    />
                </td>
            </ng-container>

      <ng-container matColumnDef="date">
        <th width="16%" mat-header-cell *matHeaderCellDef> Data </th>
        <td width="16%" mat-cell *matCellDef="let row">
          {{ row.createdAt | date : 'dd/MM/yyyy' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="hour">
        <th width="16%" mat-header-cell *matHeaderCellDef> Hora </th>
        <td width="16%" mat-cell *matCellDef="let row">
          {{ row.createdAt | date : 'hh:mm:ss z' }}
        </td>
      </ng-container>

      <ng-container matColumnDef="usersCount">
        <th width="16%" mat-header-cell *matHeaderCellDef> Total de Usuários </th>
        <td width="16%" mat-cell *matCellDef="let row">
          {{ row.totalUsers }}
        </td>
      </ng-container>

      <ng-container matColumnDef="newUsersCount">
        <th width="16%" mat-header-cell *matHeaderCellDef> Novos Usuários </th>
        <td width="16%" mat-cell *matCellDef="let row">
          {{ row.newUserCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="updatedUsers">
        <th width="16%" mat-header-cell *matHeaderCellDef> Usuários Atualizados </th>
        <td width="16%" mat-cell *matCellDef="let row">
          {{ row.updatedUserCount }}
        </td>
      </ng-container>

      <ng-container matColumnDef="blockedUsers">
        <th width="12%" mat-header-cell *matHeaderCellDef> Usuários Bloqueados </th>
        <td width="12%" mat-cell *matCellDef="let row">
          {{ row.blockedUserCount }}
        </td>
      </ng-container>

            <ng-container matColumnDef="actions">
                <th width="8%" mat-header-cell *matHeaderCellDef> Detalhes</th>
                <td width="8%" mat-cell *matCellDef="let row">
                    <ion-icon slot="icon-only" src="/assets/imgs/view.svg" style="color: var(--ion-color-primary); height: 24px; width: 24px; cursor: pointer" (click) = "viewDetails(row)"></ion-icon>
                </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>

        <app-pagination *ngIf="processesCount"
                        [setPagination]="{
        'itemsCount': processesCount,
        'pageSize': pageSize
      }"
                        (goToPage)="goToPage($event)"
        ></app-pagination>
    </div>
</ion-content>